import Vue from "vue";
import Router from "vue-router";
import Index from "@/views/Index.vue";
import PayNotify from "@/views/PayNotify.vue";
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
    },
    {
      path: "/payNotify",
      name: "PayNotify",
      component: PayNotify,
    },
  ],
});
